// extracted by css-extract-rspack-plugin
export default {"divider":"FilterGroups-module__divider__RUyZZ","topDivider":"FilterGroups-module__topDivider__liizn","footerText":"FilterGroups-module__footerText__lNs_L"};